import { Component, Input } from '@angular/core';
import { Job } from '../job.model';
import { CommonModule } from '@angular/common';
import { MomentModule } from 'ngx-moment';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TooltipModule as pTooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-jobs-groups-due',
    templateUrl: './jobs-groups-due.component.html',
    styleUrls: ['./jobs-groups-due.component.scss'],
    imports: [
        CommonModule,
        MomentModule,
        TooltipModule,
        pTooltipModule
    ]
})
export class JobsGroupsDueComponent {
    @Input() job: Job;

    getDueDate(days: number) {
        return new Date(this.job.due_date).setDate(
            new Date(this.job.due_date).getDate() - days
        );
    }
}